/**
 * Titular (Owner) section for CreateSolicitudDialog
 */
import React from 'react';
import { Label } from '../ui/label';
import { Input } from '../ui/input';

const TitularSection = ({ formData, onFieldChange }) => {
  return (
    <div className="border border-[#E8E8E7] rounded-lg p-3 sm:p-4">
      <h3 className="text-sm sm:text-base lg:text-lg font-semibold text-[#2D2D2D] mb-2 sm:mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>
        Datos del Titular
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4">
        <div>
          <Label className="text-xs sm:text-sm">Nombre *</Label>
          <Input
            value={formData.cliente_nombre}
            onChange={(e) => onFieldChange('cliente_nombre', e.target.value)}
            className="border-[#c5b8a2] text-sm"
            required
            data-testid="titular-nombre"
          />
        </div>
        <div>
          <Label className="text-xs sm:text-sm">Email *</Label>
          <Input
            type="email"
            value={formData.cliente_email}
            onChange={(e) => onFieldChange('cliente_email', e.target.value)}
            className="border-[#c5b8a2] text-sm"
            required
            data-testid="titular-email"
          />
        </div>
        <div>
          <Label className="text-xs sm:text-sm">Teléfono *</Label>
          <Input
            value={formData.cliente_telefono}
            onChange={(e) => onFieldChange('cliente_telefono', e.target.value)}
            className="border-[#c5b8a2] text-sm"
            placeholder="+51987654321"
            required
            data-testid="titular-telefono"
          />
        </div>
      </div>
    </div>
  );
};

export default TitularSection;
